
    // JQUERY.MAGNIFIC-POPUP
    if ($.fn.magnificPopup) {
        // image
        $('.image-popup').magnificPopup({type:'image'});
        $('.image-group-popup').each(function() {
            $(this).magnificPopup({
                delegate: 'a',
                type: 'image',
                gallery: {
                    enabled: true
                }
            });
        });
        // iframe
        $('.iframe-popup').magnificPopup({type:'iframe'});
    $('.iframe-group-popup').each(function() {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'iframe',
            gallery: {
                enabled: true
            }
        });
    });

    $('.zoom-gallery').magnificPopup({
            delegate: 'a',
            type: 'image',
            closeOnContentClick: false,
            closeBtnInside: false,
            overflowY: 'scroll',
            mainClass: 'mfp-with-zoom mfp-img-mobile',
            image: {
            verticalFit: true,
                // titleSrc: function(item) {
                //  return item.el.attr('title') + ' &middot; <a class="image-source-link" href="'+item.el.attr('data-source')+'" target="_blank">image source</a>';
                // }
            },
            gallery: {
                enabled: true
            },
            zoom: {
                enabled: true,
                duration: 300, // don't foget to change the duration also in CSS
                opener: function(element) {
                    return element.find('img');
                }
            },
            fixedContentPos: false,
            callbacks: {
                open: function() {
                    jQuery('body').addClass('noscroll');
                },
                close: function() {
                    jQuery('body').removeClass('noscroll');
                }
            }
        });
    
        $('.gallery-wrapper').magnificPopup({
                delegate: 'div a',
                type: 'image',
                gallery: {
                        enabled: true,
                        //navigateByImgClick: true
                },
                //fixedContentPos: false
        });

    }
